/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAwardBlockFragment} from '@amblique/contentful/app/contentful/fragments/award-block/base-award-block.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';

export const FullAwardBlockFragment = gql`
  ${BaseAwardBlockFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}

  fragment FullAwardBlockFragment on AwardBlock {
    ...BaseAwardBlockFragment

    leftContentCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
      }
    }
    leftContentCursorCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
      }
    }
    rightContentCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
      }
    }
    rightContentCursorCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
      }
    }
  }
`;
